import { useTranslation } from 'react-i18next'

import { RemakeResult } from './RemakeResult'
import { RemakeStarter } from './RemakeStarter'

interface ListingRemakePanelProps {
  jobId: string
}

/**
 * Remake studio orchestrator: starts a remake (marketplace + optional fields),
 * then shows progress / text diff + image slots + version switching.
 */
export function ListingRemakePanel({ jobId }: ListingRemakePanelProps) {
  const { t } = useTranslation()

  return (
    <section className="listing-builder-remake-panel space-y-6" aria-label={t('listingBuilder.remake.title')}>
      <RemakeStarter jobId={jobId} />
      <RemakeResult jobId={jobId} />
    </section>
  )
}
